import React from "react";

const Helmet = (props) => {
  document.title = `Kim Cab - ${props.title}`;
  return <div className="main">{props.children}</div>;
};

export default Helmet;
